import React from 'react'
import PropTypes from 'prop-types'
import { formatDate, formatPhoneNumber, stripHTML } from '../../../utils/helpers';
import { generateGoogleDirection } from '../../../utils/googleMapHelper';
import IconText from '../../1_Atoms/IconText/IconText';
import Link from '../../1_Atoms/Link/Link';
import { languageController } from '../../../controllers/language/languageController';
import Image from '../../1_Atoms/Image/Image';
import carDefault from '../../../assets/images/jellyDefault.png';

function CalloutBoxFull({
  vehicleData,
  dealerData,
  userPosition,
  dateAndTimeData,
  isOwnVehicleType,
}) {
  const { name: dealerName, address_line_1, city, post_code, website, phone_number, geolocation } = dealerData || {};

  const formattedPhoneNumber = phone_number ? formatPhoneNumber(phone_number) : '';

  return (
    <div className="mz-callout-box mz-callout-box--full">
      {/* Vehicle */}
      {
        vehicleData && (
          isOwnVehicleType ? (
            <div className="mz-callout-box__item mz-callout-box__item--vehicle mz-callout-box__item--vehicle-own-type">
              <h5 className="mz-callout-box__car-name">{vehicleData.modelYear} {vehicleData.model}</h5>
              {
                vehicleData.kilometers && (
                  <div className="mz-callout-box__car-odometer">
                    <span className="strong">{languageController.getCopy('global', 'odometer')}:</span> {vehicleData.kilometers}
                  </div>
                )
              }
              {
                vehicleData.vin && (
                  <div className="mz-callout-box__car-vin">
                    <span className="strong">{languageController.getCopy('global', 'vin')}:</span> {vehicleData.vin}
                  </div>
                )
              }
            </div>
          ) : (
              <div className="mz-callout-box__item mz-callout-box__item--vehicle">
                {/* TODO: Add car image src once api is ready */}
                <Image src={carDefault} alt={''} isLazy={false} />
                <h5 className="mz-callout-box__car-name">{vehicleData.title}</h5>
                <p className="m-0">
                  {vehicleData.description ? stripHTML(vehicleData.description) : ''}
                  {vehicleData.msrp ? ` – ${languageController.getCopy('global', 'from')} $${vehicleData.msrp}` : ''}
                </p>
              </div>
            )
        )
      }
      {/* Date and time */}
      {
        dateAndTimeData && (
          <div className="mz-callout-box__item mz-callout-box__item--date-and-time">
            <div className="mz-callout-box__date-item">
              <span className="strong">{languageController.getCopy('global', 'date')}:</span> {formatDate(dateAndTimeData.date)}
            </div>
            <div className="mz-callout-box__date-item">
              <span className="strong">{languageController.getCopy('global', 'timePreference')}:</span> <span className="mz-callout-box__date-item-time">{dateAndTimeData.time}</span>
            </div>
          </div>
        )
      }
      {/* Dealer */}
      {
        dealerData && (
          <div className="mz-callout-box__item mz-callout-box__item--dealer">
            <h6 className="mz-callout-box__dealer-name">{dealerName}</h6>
            <p className="font-small ls-normal m-0">{address_line_1}, {city}, {post_code}</p>
            <p className="font-small ls-normal m-0 text--grey">
              {geolocation.distance && geolocation.distance.toFixed(0) > 0 ? geolocation.distance.toFixed(2) + ' km' : ''}
            </p>
            <div className="mz-callout-box__dealer-links">
              {
                website && (
                  <IconText
                    label={<Link text={languageController.getCopy('global', 'dealerWebsite')} href={website} target="_blank" />}
                    iconType="website"
                    iconSize={1}
                    iconColour="red"
                    iconTop="1px"
                    className="caption"
                  />
                )
              }
              {
                formattedPhoneNumber && (
                  <IconText
                    label={<Link text={formattedPhoneNumber} href={`tel:${formattedPhoneNumber}`} />}
                    iconType="phone"
                    iconSize={1}
                    iconColour="red"
                    iconTop="1px"
                    className="caption"
                  />
                )
              }
              {
                userPosition && (
                  <IconText
                    label={<Link text={languageController.getCopy('global', 'dealerDirections')} href={generateGoogleDirection(userPosition, { lat: geolocation.latitude, lng: geolocation.longitude })} target="_blank" />}
                    iconType="address"
                    iconSize={1}
                    iconColour="red"
                    iconTop="1px"
                    className="caption"
                  />
                )
              }
            </div>
          </div>
        )
      }
    </div>
  )
}

CalloutBoxFull.propTypes = {
  vehicleData: PropTypes.object,
  dealerData: PropTypes.object,
  userPosition: PropTypes.object,
  dateAndTimeData: PropTypes.object,
  isOwnVehicleType: PropTypes.bool,
}

CalloutBoxFull.defaultProps = {
  isOwnVehicleType: false,
}

export default CalloutBoxFull